import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { selectCurrentToken } from './authSlice';
import { useSelector } from 'react-redux';
import useRefreshToken from './../../hooks/useRefreshToken';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const token = useSelector(selectCurrentToken);

    useEffect(() => {
        let isMounted = true;
        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.error(err.message);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        if (!token) {
            verifyRefreshToken();
        } else {
            setIsLoading(false);
        }

        return () => isMounted = false;
    }, [refresh, token]);

    return (
        <>
            {isLoading
                ? <div>Loading...</div>
                : <Outlet context={{ isPersistLogin: true }} />}
        </>
    );
};

export default PersistLogin;
